import React, { useEffect, useState } from 'react'
import TimeAgo from '../../common/TimeAgo.jsx'
import * as timeago from 'timeago.js';
import BadgeManager from '../../common/badges/BadgeManager.jsx';
import BadgeBudget from '../../common/badges/BadgeBudget.jsx'
import TooltipSimple from '../../common/tooltips/TooltipSimple.jsx';
import ButtonPriorityDropdown from '../../common/buttons/ButtonPriorityDropdown';
import {ajaxFetcherPost } from '../../../../fetchers';
import { useTranslation } from 'react-i18next';

import { displayRequestRef } from '../../../../utils.js';
import useRefreshStore from '../../../../stores/refreshStore';

export default function RequestsHotelsCardTitle(props){
	const {
		id,
		title, 
		refRequest,
		checkin, 
		checkout,
		manager,
		showTitle = true,
		showManager = false,
		showBudget = false,
		badgeBgColor,
		status,
		echeancier,
		totalPayed,
		totalHt,
		devise,
		noLink = false,
		prioritySlug
	} = props

	const { t: gctrad } = useTranslation();
	const { createRefresh } = useRefreshStore();

	const [priorityStatusSlug, setPriorityStatusSlug] = useState(prioritySlug);
	
	useEffect(() => {
		setPriorityStatusSlug(prioritySlug);
	}, [prioritySlug]);
	
	const setRequestHotelStatusPriority  = (priority, id) => {
		const postData = new URLSearchParams([
			['priority', priority.slug],
			['requests_hotels_id', id],
		])

		ajaxFetcherPost({
			url: ENV.base_lang_url + "myspace/providers//requests_hotels/ajax/set_requests_hotels_status_priority",
			data: postData
		}).then((response) => {
			if(response.success) {
				nav.infos(gctrad('La priorité du dossier a été modifiée'));
				setPriorityStatusSlug(response.slug);

				createRefresh({
					refreshKey: 'refreshRequestHotelPriority',
					refreshId: id,
					item: priority
				});

			}
			else{
				nav.infos_error(gctrad('myspace Une erreur est survenue'), {autoclose: false});
			}
		})
	}
	
	return (
		<div className="d-flex align-items-center">
			<span className="d-inline-block mr-2">
				<ButtonPriorityDropdown 
					onChange={(priority) => setRequestHotelStatusPriority(priority,id)}
					id={id}
					value={priorityStatusSlug}
				/>  
			</span>
			<h2 className="h4 font-weight-bold m-0">
				{showTitle &&
					<TooltipSimple
						title={'#' + displayRequestRef(refRequest) + ' | ' + title}
					>
						<span
							className="mr-md-2"
						>
							{title.truncate(50)}
						</span>	
					</TooltipSimple>
				}
				<span className="d-block d-md-inline-block h6 font-weight-normal m-0 mr-2">
					{checkin == checkout ?
						'le'.trad().replace('%1',(checkin.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'})))
						:
						'du_au'.trad().replace('%1',(checkin.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'}))).replace('%2',(checkout.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'}))).ucFirst()
					}
				</span>
			</h2>
			
			{
				!noLink ? 
				(
					
					showManager && (
						<a 
							data-target={'providers//requests_hotels/manage_infos/' + id} 
							data-part={'+'}
							className="js-nav get_part_link mr-2"
						>
							<BadgeManager manager={manager} bgColor={badgeBgColor}/>
						</a>
					)
						
				)
				:
				(
					showManager && (
						<span className="mr-2">
							<BadgeManager manager={manager} bgColor={badgeBgColor} />
						</span>
					)
	
				)
			}
			
			<span className="mr-2">
				{
					!noLink ? 
					(
						
						showBudget && (<a href="#"><BadgeBudget 
							budget={status == 'rh_attente_paiement_client' && echeancier.id ? totalPayed.formatMoneyK(devise) + ' / ' + totalHt.formatMoneyK(devise) : totalHt.formatMoneyK(devise)} 
							bgColor={badgeBgColor}
						/></a>)
							
					)
					:
					(
						showBudget && 
						(
							<BadgeBudget 
								budget={status == 'rh_attente_paiement_client' && echeancier.id ? totalPayed.formatMoneyK(devise) + ' / ' + totalHt.formatMoneyK(devise) : totalHt.formatMoneyK(devise)} 
								bgColor={badgeBgColor}
							/>
						)
					)
				}				
			</span>
		</div>
	);
}